// import Sider from 'antd/es/layout/Sider'
import React from 'react'
import InputText from '../common/InputText'
import { Form, Menu, Tooltip } from 'antd'
import { useEffect, useMemo, useRef, useState, useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import { Layout } from 'antd'
import {
  ApiOutlined,
  BoxPlotOutlined,
  BranchesOutlined,
  BuildOutlined,
  CarOutlined,
  ClusterOutlined,
  CodeSandboxOutlined,
  DeploymentUnitOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FileTextOutlined,
  NodeExpandOutlined,
  NodeIndexOutlined,
  ProfileOutlined,
  PushpinOutlined,
  SafetyOutlined,
  TagOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons'
import { useLocation } from 'react-router-dom'
import useDebouncedValue from '../../utils/common_function'
import { useThemeContext } from '../../context/theme_context'
import { DARK_MODE } from '../../constants'
import { useIntl } from 'react-intl'

const { Sider } = Layout

function Sidebar(props) {
  const { vehicleId, collapsed, className, hasBlockers } = props
  const { mode } = useThemeContext()
  const location = useLocation()
  const [searchMenuItem, setSearchMenuItem] = useState('')
  /* Controls expanded submenu - We have nested submenu items, hence we also need to control "openKeys" to keep parent submenu expanded. */
  const [openKeys, setOpenKeys] = useState([])
  const [cachedOpenKeys, setCachedOpenKeys] = useState([])
  /* Store key for all menu items */
  const allKeys = useRef(null)
  const prevCollapsed = useRef(collapsed)
  const menuContainerRef = useRef(null)
  const debouncedSearch = useDebouncedValue(searchMenuItem, 500)
  const intl = useIntl()
  
  /* Menu Data */
  const menuData = useMemo(() => [
    { subroute: 'importers', icon: FileTextOutlined, label: intl.formatMessage({id: 'sidebar.importers'}) },
    {
      subroute: 'dtcs',
      icon: ExclamationCircleOutlined,
      label: intl.formatMessage({id: 'sidebar.dtcs'}),
      submenu: [
        { subroute: 'listing', label: intl.formatMessage({id: 'sidebar.taMappings'}) },
        { subroute: 'tracer_mapping', label: intl.formatMessage({id: 'sidebar.csMappings'}) },
        { subroute: 'memos', label: intl.formatMessage({id: 'sidebar.csMemos'}) },
      ],
    },
    { subroute: 'connector_views', icon: CarOutlined, label: intl.formatMessage({id: 'sidebar.vehicleViews'}) },
    {
      subroute: 'power_distributions',
      icon: ThunderboltOutlined,
      label: intl.formatMessage({id: 'sidebar.powerDistribution'}),
    },
    {
      subroute: 'plugins',
      icon: BuildOutlined,
      label: intl.formatMessage({id: 'sidebar.plugin'}),
      submenu: [
        { subroute: 'sales_code_complexity', label: intl.formatMessage({id: 'sidebar.salesCodeComplexity'}) },
        { subroute: 'def', label: intl.formatMessage({id: 'sidebar.defPlugin'}) },
        { subroute: 'capital_harness', label: intl.formatMessage({id: 'sidebar.capitalHarness'}) },
      ],
    },
    { subroute: 'inlines', icon: NodeExpandOutlined, label: intl.formatMessage({id: 'sidebar.inlines'}) },
    { subroute: 'modules', icon: BoxPlotOutlined, label: intl.formatMessage({id: 'sidebar.modules'}) },
    { subroute: 'devices', icon: CodeSandboxOutlined, label: intl.formatMessage({id: 'sidebar.devices'}) },
    {
      subroute: 'inspection_points',
      icon: PushpinOutlined,
      label: intl.formatMessage({id: 'sidebar.inspectionPoints'}),
    },
    { subroute: 'wire', icon: NodeIndexOutlined, label: intl.formatMessage({id: 'sidebar.wires'}) },
    { subroute: 'connector', icon: ApiOutlined, label: intl.formatMessage({id: 'sidebar.connector'}) },
    { subroute: 'sales_code', icon: TagOutlined, label: intl.formatMessage({id: 'sidebar.salesCode'}) },
    {
      subroute: 'functional-diagram',
      icon: ClusterOutlined,
      label: intl.formatMessage({id: 'sidebar.functionalDiagram'}),
    },
    { subroute: 'harnesses', icon: ProfileOutlined, label: intl.formatMessage({id: 'sidebar.harnessList'}) },
    { subroute: 'circuit', icon: BranchesOutlined, label: intl.formatMessage({id: 'sidebar.circuit'}) },
    {
      subroute: 'device_connections',
      icon: DeploymentUnitOutlined,
      label: intl.formatMessage({id: 'sidebar.deviceConnections'}),
    },
    {
      subroute: 'validation',
      icon: SafetyOutlined,
      label: intl.formatMessage({id: 'sidebar.validation'}),
      submenu: [
        { subroute: 'dtc_mapping_validation', label: intl.formatMessage({id: 'sidebar.dtcMappingValidation'}) },
        { subroute: 'graph_missing_images', label: intl.formatMessage({id: 'sidebar.graphMissingImages'}) },
      ],
    },
    { subroute: 'visual-aid', icon: EyeOutlined, label: intl.formatMessage({id: 'sidebar.visualAid'}) },
  ], [intl])
  /* const menuData = useMemo(() => [
    { subroute: 'importers', icon: FileTextOutlined, label: 'Importers / Downloads' },
    {
      subroute: 'dtcs',
      icon: ExclamationCircleOutlined,
      label: 'DTCs',
      submenu: [
        { subroute: 'listing', label: 'Tracer Authoring Mappings' },
        { subroute: 'tracer_mapping', label: 'Crowd Sourced Mappings' },
        { subroute: 'memos', label: 'Crowd Sourced Memos' },
      ],
    },
    { subroute: 'connector_views', icon: CarOutlined, label: 'Vehicle Views' },
    {
      subroute: 'power_distributions',
      icon: ThunderboltOutlined,
      label: 'Power Distribution',
    },
    {
      subroute: 'plugins',
      icon: BuildOutlined,
      label: 'Plugin',
      submenu: [
        { subroute: 'sales_code_complexity', label: 'Sales Code Complexity' },
        { subroute: 'def', label: 'Def Plugin' },
        { subroute: 'capital_harness', label: 'Capital Harness' },
      ],
    },
    { subroute: 'inlines', icon: NodeExpandOutlined, label: 'Inlines' },
    { subroute: 'modules', icon: BoxPlotOutlined, label: 'Modules' },
    { subroute: 'devices', icon: CodeSandboxOutlined, label: 'Devices' },
    {
      subroute: 'inspection_points',
      icon: PushpinOutlined,
      label: 'Inspection Points',
    },
    { subroute: 'wire', icon: NodeIndexOutlined, label: 'Wires' },
    { subroute: 'connector', icon: ApiOutlined, label: 'Connector' },
    { subroute: 'sales_code', icon: TagOutlined, label: 'Sales Code' },
    {
      subroute: 'functional-diagram',
      icon: ClusterOutlined,
      label: 'Functional Diagram',
    },
    { subroute: 'harnesses', icon: ProfileOutlined, label: 'Harness List' },
    { subroute: 'circuit', icon: BranchesOutlined, label: 'Circuit' },
    {
      subroute: 'device_connections',
      icon: DeploymentUnitOutlined,
      label: 'Device Connections',
    },
    {
      subroute: 'validation',
      icon: SafetyOutlined,
      label: 'Validation',
      submenu: [
        { subroute: 'dtc_mapping_validation', label: 'DTC Mapping Validation' },
        { subroute: 'graph_missing_images', label: 'Graph Missing Images' },
      ],
    },
    { subroute: 'visual-aid', icon: EyeOutlined, label: 'Visual Aid' },
  ], []) */

  /* Filter "menuData" based on search term */
  const filterMenu = useCallback((data, search) => {
    if (!search) return data

    return data
      .map((menuItem) => {
        const match = menuItem.label
          .toLowerCase()
          .includes(search.toLowerCase())
        if (menuItem.submenu) {
          const filteredChildren = filterMenu(menuItem.submenu, search)
          if (filteredChildren.length > 0 || match) {
            return {
              ...menuItem,
              submenu: filteredChildren,
            }
          }
        }

        if (match) return menuItem

        return null
      })
      .filter(Boolean)
  }, [])

  /* Update "filteredMenuData" used to cerate "menuItems" when "debouncedSearch" value changes */
  const filteredMenuData = useMemo(() => {
    return filterMenu(menuData, debouncedSearch)
  }, [menuData, debouncedSearch, filterMenu])

  /* Create Menu Items from "filteredMenuData" */
  const createMenuItems = useCallback((data, parentRoute = null) => {
    const base = `/vehicles/${vehicleId}`

    return data.map(({ subroute, icon: Icon, label, submenu }) => {
      const hasChildren = Array.isArray(submenu)
      const key = parentRoute
        ? `${base}/${parentRoute}/${subroute}`
        : `${base}/${subroute}`
      allKeys.current.push(key)

      // Render label with Tooltip for parent menu items when collapsed & use NavLink for leaf items
      /* let renderedLabel
      if (hasChildren) {
        // Parent menu item with children - show Tooltip when collapsed
        renderedLabel = collapsed ? (
          <Tooltip title={label} placement="right" mouseEnterDelay={0.3} destroyOnHidden>
            <span>{label}</span>
          </Tooltip>
        ) : (
          label
        )
      } else {
        // Child menu item or menu item without children - render as NavLink
        renderedLabel = <NavLink to={key}>{label}</NavLink>
      } */

      return {
        key,
        icon: Icon ? <Icon /> : undefined,
        mode: hasChildren ? "inline" : undefined,
        // label: renderedLabel,
        label: hasChildren ? (
          <span data-testid="sidebar-group" data-menu={subroute}>{label}</span>
        ) : (
          <NavLink to={key} data-testid="sidebar-item" data-menu={subroute}>{label}</NavLink>
        ),
        title: collapsed && hasChildren ? label : undefined,
        disabled: hasBlockers,
        children: hasChildren ? createMenuItems(submenu, subroute) : undefined,
      }
    })
  }, [vehicleId, collapsed, hasBlockers])

  /* Create "menuItems" to be consumed by Menu Component whenever "filteredMenuData" changes */
  const menuItems = useMemo(() => {
    allKeys.current = []
    return createMenuItems(filteredMenuData)
  }, [filteredMenuData, vehicleId, createMenuItems])

  /* Search & select the "selectedMenuKey" based on "location" */
  const selectedMenuKey = useMemo(() => {
    return allKeys.current.reduce((bestMatch, key) => {
      const path = location.pathname
      const routeMatch = path === key || path.startsWith(`${key}/`)
      if (routeMatch && key.length > bestMatch.length) {
        return key
      }
      return bestMatch
    }, '')
  }, [location.pathname])

  /* Get "openKeys" based on location */
  const getOpenKeys = useCallback((pathname) => {
    const segments = pathname.split('/').filter(Boolean)
    const keys = []
    // Build keys for all parent levels up to the current item
    for (let i = 2; i < segments.length; i++) {
      keys.push(`/vehicles/${segments.slice(1, i + 1).join('/')}`)
    }
    return keys
  }, [])

  /* Auto-expand parent menu items based on location (on refresh or navigation) */
  useEffect(() => {
    if (collapsed) return

    const opnKeys = getOpenKeys(location.pathname)
    setOpenKeys(opnKeys)

    const container = menuContainerRef.current
    if (!container) return

    requestAnimationFrame(() => {
      const activeItem = container.querySelector(
        '.ant-menu-item-selected, .ant-menu-submenu-selected'
      )
      activeItem?.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      })
    })
  }, [location.pathname, collapsed, getOpenKeys])

  /* Cache and restore openKeys when toggling collapsed state */
  useEffect(() => {
    // * Expanded -> Collapsed
    if (!prevCollapsed.current && collapsed) {
      setCachedOpenKeys(openKeys)
      setOpenKeys([])
    }
    // * Collapsed -> Expanded
    if (prevCollapsed.current && !collapsed) {
      const restoredKeys = getOpenKeys(location.pathname)
      setOpenKeys(restoredKeys.length > 0 ? restoredKeys : cachedOpenKeys)
    }

    prevCollapsed.current = collapsed
  }, [collapsed, openKeys, cachedOpenKeys, location.pathname, getOpenKeys])

  return (
    <Sider
      width={261}
      collapsible={false}
      collapsed={collapsed}
      className={`custom-sider ${collapsed ? 'sider-collapsed' : 'sider-expanded'} ${className}`}
    >
      <Form
        className="vehicle-menu-search"
        style={{ display: collapsed ? 'none' : 'block' }}
      >
        <InputText
          name="search"
          placeholder={intl.formatMessage({id: 'sidebar.searchPlaceholder'})}
          value={searchMenuItem}
          type="search"
          isRequired={false}
          disabled={hasBlockers}
          onChange={(value) => {
            setSearchMenuItem(value)
          }}
        />
      </Form>

      <div ref={menuContainerRef} className="menu-container">
        <Menu
          mode="inline"
          triggerSubMenuAction="hover"
          items={menuItems}
          selectedKeys={selectedMenuKey ? [selectedMenuKey] : []}
          openKeys={collapsed ? undefined : openKeys}
          onOpenChange={(keys) => {
            if (!collapsed) {
              setOpenKeys(keys)
            }
          }}
          className={`custom-menu`}
        />
      </div>
    </Sider>
  )
}

export default React.memo(Sidebar)
